module.exports = __webpack_public_path__ + "img/stars_inset.6656337e.png";